import { useEffect, useState } from 'react';
import { useDebounce } from './useDebounce';

/**
 * Хук useWindowResize отслеживает изменение ширины и высоты окна браузера
 * и возвращает текущее значение ширины и высоты с дебаунсом.
 *
 * @param {number} delay - Задержка дебаунса в миллисекундах.
 * @returns Объект с текущей шириной и высотой окна (`width`, `height`).
 * @example const { width, height } = useWindowResize(500)
 */
export const useWindowResize = (delay = 500) => {
  const [size, setSize] = useState({ width: null, height: null });

  useEffect(() => {
    const updateSize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    updateSize();

    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const debouncedWidth = useDebounce(size.width, delay);
  const debouncedHeight = useDebounce(size.height, delay);

  return { width: debouncedWidth, height: debouncedHeight };
};
